import Box from '@mui/material/Box';
import { ReactElement } from 'react';

import Loading from '../Loading';

export default function LoadingContainer(): ReactElement {
  return (
    <Box flexDirection="column" flexGrow={1} height="100%" justifyContent="center" alignItems="center">
      <Loading />
    </Box>
  );
}
